import { useEffect, useState, useContext } from "react";
import ModalPopup from "./components/ModalPopup";
import { StepContext, uuidv4 } from "./components/StepContext";
import Stepper from "./components/stepper/Stepper";
import Step1 from "./components/steps_pages/Step1";
import Step2 from "./components/steps_pages/Step2";
import Step3 from "./components/steps_pages/Step3";
import Step4 from "./components/steps_pages/Step4";
import Step5 from "./components/steps_pages/Step5";
import Step6 from "./components/steps_pages/Step6";
import StepConferma from "./components/steps_pages/StepConferma";
import StepSuccesso from "./components/steps_pages/StepSuccesso";
import { useTitle } from "./hooks/useTitle";
import logo from "./img/logo.png";

function DebugInfo() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return <div style={{color:"white",backgroundColor:"red"}}>
      <p><b>Modalità DEBUG</b></p>
      <p><b>ENV API:</b> {process.env.REACT_APP_API_URL}</p>
    </div>
  }else{
    return null;
  }
}


function App() {
  useTitle("Benvenuto in Umbria Energy ");
  const [step, setStep] = useState(1);
  //const { contratto, setContratto } = useContext(StepContext);

  const setCurrentStep = () => {

    switch (step) {
      case 1: return <Step1 />
      case 2: return <Step2 />
      case 3: return <Step3 />
      case 4: return <Step4 />
      case 5: return <Step5 />
      case 6: return <Step6 />
      case 7: return <StepConferma />
      case 100: return <StepSuccesso />

      default: return <Step1 />
        break;
    }
  }

  const [modalShow, setModalShow] = useState(false);


  useEffect(() => {
    //Alla prima inizializzazione imposto l'uid della richiesta
    StepContext.contratto = { uid: uuidv4() };
    console.log("Versione: "+process.env.REACT_APP_VERSION);
    console.log("Sviluppato da KD software - https://www.kdsoftware.it");
  }, []);

  return (
    <><div style={{position:"absolute",top:"5px",left:"5px",fontSize:"8px"}} title="Sviluppato da KD software - www.kdsoftware.it">
        {process.env.REACT_APP_VERSION}
      </div> 
      <DebugInfo />
      <div style={{ marginTop: "5px", width: "100%", display: "flex", justifyContent: "center", marginBottom: "25px" }}>
        <img src={logo}></img>
      </div>

      <div style={{ marginTop: "5px", width: "100%", display: "flex", justifyContent: "center", marginBottom: "25px" }}>
        <Stepper steps={7} currentStep={step} />
      </div>
      <ModalPopup title='ciao' show={modalShow} onHide={() => setModalShow(false)} />
      <StepContext.Provider value={{ step, setStep }}>
        {setCurrentStep()}

        <div className="footer">

          Gentile cliente, se ti occorre aiuto o maggiori informazioni sulla compilazione della richiesta siamo a tua disposizione!
          Puoi contattarci tramite WhatsApp al <a href="https://wa.me/+393274045985?text=MyUmbriaEnergy" target="_blank">+39 327-4045985</a>,
          contattano il servizio Clienti al numero <a href="tel:+39800060010" target="_blank">+39 800 060 010</a> (da cellulare <a href="tel:+390744300281" target="_blank">+390744300281</a>) oppure tramite mail scrivendo all'indirizzo <a href="mailto:info@umbriaenergy.it">info@umbriaenergy.it</a>
        </div>

      </StepContext.Provider>


    </>
  );
}

export default App;
